import { render, staticRenderFns } from "./SkeletonBox.vue?vue&type=template&id=f76340ec&"
import script from "./SkeletonBox.vue?vue&type=script&lang=js&"
export * from "./SkeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBox.vue?vue&type=style&index=0&id=f76340ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports